export default __webpack_public_path__ + "static/media/vacio.be1bd561.png";